import { el } from '../lib/dom';
import { navigate } from '../lib/navigate';
import type { View } from '../lib/router';

export const notFoundView: View = (container) => {
  container.append(
    el(
      'main',
      { class: 'screen screen--centered' },
      el('h1', { class: 'screen__title', text: 'Nothing here' }),
      el('p', {
        class: 'screen__body',
        text: 'That link does not point anywhere. Sessions expire after an hour, so it may simply be old.',
      }),
      el(
        'button',
        { class: 'button button--primary', type: 'button', onclick: () => navigate('/') },
        'Start fresh',
      ),
    ),
  );
};
